import React from 'react';
import './About.css';

function About() {
  return (
    <section className="about" id="about">
      <h2>About Me</h2>
      <p>
        Hi, I'm Matrika Bhatta (Mausam) — a passionate Frontend Developer and Graphic Designer who enjoys transforming ideas into meaningful digital experiences. Whether crafting a sleek, responsive website or designing striking visuals, I strive to blend creativity with practical functionality.
      </p>
      <br />
      <p>
        I have expertise in developing contemporary, responsive web applications and designing visually appealing products that combine creativity with functionality and usability. From developing user interfaces to designing graphics, I am keen on making sure that all my creations not only look good but work well for the user.
      </p>
      <br />
      <p>
        My toolkit includes React.js, Next.js, JavaScript, HTML, CSS, WordPress, Figma, Canva, and Adobe Creative Suite. I enjoy exploring new technologies, solving problems through code, and continuously improving my design and development skills.
      </p>
    </section>
  );
}

export default About;

